<template>
  <div id="app">
    <div class="h5-app">
<!--      <TempDayPack />-->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
      <!--付费dialog-->
      <div class="toast-overlay align jus" v-if="overlayShow" @click="$store.commit('WRITEOVERLAYSHOW', { status: false })">
        <div @click.stop="() => {}">
          <LoginOrPayModal />
        </div>
      </div>
      <!--登录dialog-->
      <div class="toast-overlay align jus" v-if="loginShow" @click="$store.commit('WRITELOGINSHOW', { status: false })">
        <div @click.stop="() => {}">
          <LoginModule />
        </div>
      </div>
      <!--IOS支付跳转-->
      <div class="toast-overlay align jus" v-if="customShow" @click="$store.commit('showCustomDialog')">
        <div @click.stop="() => {}">
          <div class="login-module align direction">
            <div class="login-header">请联系客服获取优惠</div>
            <div @click="goCustom" class="login">联系客服</div>
          </div>
        </div>
      </div>
    </div>
    <!--二维码dialog-->
    <van-dialog
      v-model="qrcodeDialog"
      :showConfirmButton="false"
      :beforeClose="showQrcodeDialog"
      closeOnClickOverlay
      showCancelButton
      cancelButtonText="关闭"
    >
      <QrcodeDialog />
    </van-dialog>
    <router-link :to="returnHref()" class="go-back align jus" v-if="!this.$route.meta.unGoHome">
      回到
      <br />首页
    </router-link>
  </div>
</template>

<script>
import LoginOrPayModal from './components/LoginOrPayModal';
import LoginModule from './components/LoginModule';
import { mapState } from 'vuex'
import QrcodeDialog from '@/components/QrcodeDialog.vue'
import {delCookie} from "@/helper/dom";
import TempDayPack from './tempDayPack.vue'
import {goMiniProgram} from "@/helper/wxprogramSDK";
export default {
  components: {
    QrcodeDialog,
    LoginOrPayModal,
    LoginModule,
    TempDayPack
  },
  data() {
    return {
      userInfo: {}
    };
  },
  computed: mapState(['overlayShow', 'loginShow', 'qrcodeDialog','customShow']),

  mounted() {
    wx?.miniProgram.postMessage( { data:{ cookie: document.cookie}})
    // 扫码生成分享图，不包裹在小程序中，不需自动登录
    if (location.href.includes('share')) {
      return;
    }
  },
  methods: {
    goCustom(){
      goMiniProgram('/pages/openCustomerServiceChat/main',{  })
    },
    autoPopQrcodeDialog() {
      if (localStorage.showQrcode) {
        localStorage.removeItem('showQrcode')
        this.$store.commit('showQrcodeDialog')
      }
    },
    showQrcodeDialog() {
      this.$store.commit('showQrcodeDialog')
    },
    // 信息完善页面一天内只跳转1次，连续3次，之后不再主动跳转，需用户触发
    goCompleteInfo() {
      if (this.userInfo.hasUserInfo) {
        return
      }
      let log = localStorage.completeInfoLog ? JSON.parse(localStorage.completeInfoLog) : []
      if (log.length >= 3 || log[0] === this.$formatTime(new Date(), 'YYYYMMDD')) {
        return
      }
      log.unshift(this.$formatTime(new Date(), 'YYYYMMDD'))
      localStorage.completeInfoLog = JSON.stringify(log)
      this.$router.push({ path: '/information/completeInfo' })
    },
    returnHref() {
      let firstPath = this.$route.path.split('/')[1];
      return ['gb', 'zr'].indexOf(firstPath) >= 0 ? `/${firstPath}` : '/';
    }
  }
};
</script>

<style lang="less" scoped>
.toast-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100000000;
}

.go-back {
  position: fixed;
  bottom: 1.8rem;
  right: 0.2rem;
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 100%;
  box-shadow: 0 0 0.2rem 0px rgba(161, 174, 191, 0.5);
  color: #a1aebf;
  font-size: 0.24rem;
  background: #fff;
  z-index: 8;
}
</style>
<style lang="less" scoped>
.login-module {
  width: 6.9rem;
  height: 3.4rem;
  background: #fbfafa;
  border-radius: 0.08rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .login-header {
    font-size: 0.36rem;
    color: rgba(74, 74, 74, 1);
    line-height: 1.92rem;
  }

  .login {
    width: 2.75rem;
    height: 0.8rem;
    border: 0.01rem solid #2a89f4;
    background: #2a89f4;
    border-radius: 0.08rem;
    text-align: center;
    line-height: 0.8rem;
    color: #fff;
    font-size: 0.28rem;
  }
}
</style>